import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ExpenditureList = () => {
    const kitchenId = localStorage.getItem("kitchen_id");

    const [entries, setEntries] = useState([]);

    useEffect(() => {
        if (!kitchenId) {
            alert("No kitchen ID found. Please login again.");
            return;
        }

        const fetchExpenditures = async () => {
            try {
                const response = await axios.get(`http://ims-backend.indevconsultancy.in/api/daily-expenditures/by-kitchen/${kitchenId}/`)

                setEntries(response.data);
            } catch (error) {
                console.error("Error fetching expenditures:", error);
                alert("Failed to load expenditure list.");
            }
        };

        fetchExpenditures();
    }, [kitchenId]);

    return (
        <div className="container mt-4">
            <h4>Daily Expenditure Report</h4>
            <table className="table table-bordered mt-3">
                <thead className="bg-secondary text-white">
                    <tr>
                        <th>#</th>
                        <th>Item Name</th>
                        <th>Quantity Used</th>
                    </tr>
                </thead>
                <tbody>
                    {entries.length === 0 ? (
                        <tr><td colSpan="3">No data found.</td></tr>
                    ) : (
                        entries.map((entry, index) => (
                            <tr key={entry.dailyexpenditure_id}>
                                <td>{index + 1}</td>
                                <td>{entry.stock_name}</td>
                                <td>{entry.expenditure_quantity}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ExpenditureList;
